import React from "react";
import { GlobalStyles, useTheme } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomToast = () => {
  const theme = useTheme();

  return (
    <>
      <GlobalStyles
        styles={{
          ".Toastify__toast-container": {
            width: "360px",
            padding: 0,
            zIndex: 9999,
            [theme.breakpoints.down("sm")]: {
              width: "90vw",
              left: "50%",
              transform: "translateX(-50%)",
              top: "12px",
              margin: 0,
            },
          },

          // 2. TOAST BUBBLE STYLING
          // We ONLY change Font and Radius here. We let Toastify handle colors.
          ".Toastify__toast": {
            fontFamily: theme.typography.fontFamily, // Match your app's font
            borderRadius: theme.appRadius.md, // Match your app's rounded corners
            marginBottom: theme.spacing(1.5),

            // Mobile adjustments for the bubble
            [theme.breakpoints.down("sm")]: {
              borderRadius: theme.appRadius.lg,
              marginBottom: theme.spacing(1),
            },
          },

          // 3. PROGRESS BAR (Optional: Match your primary color, or leave default)
          ".Toastify__progress-bar": {
            // Keep default colors or uncomment below to force your primary color
            // background: theme.palette.primary.main,
          },
        }}
      />

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme.palette.mode}
        limit={3}
      />
    </>
  );
};

export default CustomToast;
